export const NOT_AUTHENTICATED_ROUTES = [
  'SignIn',
  'Register',
  'RegisterCoupon',
  'ResetPassword',
  'AuthCallback',
];
